import type { EpiImagePropertyBlock } from './epiImagePropertyBlockType';

export const mapEpiImagePropertyBlock = (imageBlock: EpiImagePropertyBlock) => {
    return {
        srcSet:
            imageBlock.images
                ?.map((item) => {
                    const url = item.cloudinaryImageUrl || item.imageUrl;
                    if (!url) return null;

                    return {
                        srcSet: url,
                        height: item.height,
                        minWidth: item.breakpointFrom || (0 as const),
                    };
                })
                .filter(Boolean) || [],
        defaultImageUrl: imageBlock.defaultCloudinaryImageUrl || imageBlock.defaultImage?.url,
        defaultImageHeight: imageBlock.defaultImageHeight,
        imageAltText: imageBlock.altText,
    };
};
